import DetalleFichaVenta from './DetalleFichaVenta';
import { LINK_FDV } from '../../constants';

export default {
  route: {
    path: `${LINK_FDV}/:id`,
    component: DetalleFichaVenta,
  },
};



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/index.js